import React from 'react';
import {MainTop} from "../groups/group-container/main-top/Main-top";
import {ReactComponent as TestIcon} from '../../../assets/main/test/test.svg';
import {MyTabs} from "./test-tabs/tabs-container/my-tabs/My-tabs";
import {useAppSelector} from "common/hook";
import {StudentsTest} from "components/pages/test/students-test/StudentsTest";
import {TeacherTabs} from "./test-tabs/tabs-container/teacher-tabs/Teacher-tabs";
import {ROLE_DEMO_STUDENT, ROLE_STUDENT, ROLE_TEACHER} from "entities/constants/constants";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";


export const Test = () => {
    const activeTab = useAppSelector((state) => state.topTabs.activeTabs);
    const roleType = useAppSelector((state) => state.role.roleType);




    return (
        <AuthWrapper>
            <>
                {roleType === ROLE_TEACHER ? (
                    <div className="app-main">
                        <MainTop
                            title={'Тесты'}
                            tabs={false}
                            setting={false}
                            test={true}
                            link={'/test'}
                            icons={<TestIcon/>}
                        />
                        {activeTab.includes(0) && <MyTabs/>}
                        {activeTab.includes(1) && <TeacherTabs/>}
                    </div>
                ) : roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT ? (
                    <div className="app-main">
                        <MainTop
                            title={'Тесты'}
                            tabs={false}
                            setting={false}
                            test={false}
                            link={'/test'}
                            icons={<TestIcon/>}
                        />
                        <StudentsTest/>
                    </div>
                ) : null}
            </>
        </AuthWrapper>
    );
}

